var map = {
	"./SlidePluginsModule.js": 769,
	"./es.upv.paella.arrowSlidesNavigator.js": 516,
	"./es.upv.paella.frameControlButtonPlugin.js": 588,
	"./es.upv.paella.nextSlideNavigatorButton.js": 797,
	"./es.upv.paella.prevSlideNavigatorButton.js": 835,
	"./es.upv.paella.slideMapProgressBarPlugin.js": 244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 757;